import Avatar from './Avatar.vue'
import ContentLoader from './ContentLoader.vue'
import ContextMenu from '@/shared/components/ContextMenu.vue'
import ContextMenuItem from '@/shared/components/ContextMenuItem.vue'
import EmptyIndicator from './EmptyIndicator.vue'
import ExternalLink from './ExternalLink.vue'
import Hero from './Hero.vue'
import Icon from './Icon.vue'
import InfiniteLoader from './InfiniteLoader.vue'
import OverflowMenu from './OverflowMenu.vue'
import Slider from './Slider.vue'
import Tiles from './Tiles.vue'
import Tile from './Tile.vue'
import {
  BButton,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BDropdownItemButton,
  BDropdownText,
  BFormCheckbox,
  BModal,
} from 'bootstrap-vue'

export const components = {
  Avatar,
  BButton,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BDropdownItemButton,
  BDropdownText,
  BFormCheckbox,
  BModal,
  ContentLoader,
  ContextMenu,
  ContextMenuItem,
  EmptyIndicator,
  ExternalLink,
  Hero,
  Icon,
  InfiniteLoader,
  OverflowMenu,
  Slider,
  Tiles,
  Tile,
}
